export const DashBoardPage = () => {
  return (
    <>
      <div>ダッシュボード</div>
    </>
  );
};
